import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import humanTime from 'flarum/common/helpers/humanTime';
import formatPrice from '../../common/utils/formatPrice';
import labelText from '../../common/utils/labelText';
export default class ClassifiedsListingCard extends Component {
  view() {
    const d = this.attrs.discussion;
    const status = d.listingStatus() || 'active';
    const label = d.listingLabel();
    const images = d.listingImages?.() || [];
    const cover = images[0] || null;
    const price = formatPrice(d.listingPrice(), d.listingPriceMax(), d.listingCurrency());
    const date = d.lastPostedAt?.() || d.createdAt?.();
    const href = app.route.discussion(d);
    return m("section", {
      className: `olx-adcard olx-adcard__horizontal ClassifiedsListingCard ClassifiedsListingCard--${status}`,
      "data-mode": "horizontal"
    }, m("div", {
      className: "olx-adcard__content",
      "data-mode": "horizontal"
    }, m("div", {
      className: "olx-adcard__topbody",
      "data-mode": "horizontal"
    }, m(m.route.Link, {
      className: "olx-adcard__link",
      href: href,
      title: d.title()
    }, m("h2", {
      className: "olx-adcard__title"
    }, d.title())), m("div", {
      className: "olx-adcard__badges"
    }, label && m("div", {
      className: `olx-core-badge olx-core-badge--medium olx-core-badge--pill ClassifiedsListingCard-labelBadge ClassifiedsListingCard-labelBadge--${String(label).toLowerCase()}`
    }, labelText(label)), status !== 'active' && m("div", {
      className: `olx-core-badge olx-core-badge--medium olx-core-badge--pill ClassifiedsListingCard-statusBadge ClassifiedsListingCard-statusBadge--${status}`
    }, m("i", {
      className: 'fas ' + (status === 'sold' ? 'fa-check-circle' : 'fa-flag-checkered'),
      "aria-hidden": "true"
    }), ' ', app.translator.trans(`flarum-classifieds.lib.statuses.${status}`)))), m("div", {
      className: "olx-adcard__mediumbody"
    }, price && m("h3", {
      className: "olx-adcard__price"
    }, price)), m("div", {
      className: "olx-adcard__bottombody"
    }, m("div", {
      className: "olx-adcard__location-date"
    }, d.listingLocation() && m("p", {
      className: "olx-adcard__location"
    }, m("i", {
      className: "fas fa-map-marker-alt",
      "aria-hidden": "true"
    }), ' ', d.listingLocation()), date && m("p", {
      className: "olx-adcard__date"
    }, humanTime(date))))), m("div", {
      className: "ClassifiedsListingCard-mediaWrap"
    }, m("div", {
      className: "olx-adcard__media",
      "data-mode": "horizontal"
    }, cover ? m("picture", null, m("img", {
      src: cover,
      alt: d.title(),
      loading: "lazy",
      decoding: "async"
    })) : m("div", {
      className: "ClassifiedsListingCard-mediaPlaceholder"
    }, m("i", {
      className: "fas fa-camera",
      "aria-hidden": "true"
    })), images.length > 1 && m("span", {
      className: "ClassifiedsListingCard-counter"
    }, m("i", {
      className: "fas fa-images",
      "aria-hidden": "true"
    }), " ", images.length))));
  }
}
flarum.reg.add('ramon-classifieds', 'forum/components/ClassifiedsListingCard', ClassifiedsListingCard);